// extracted by mini-css-extract-plugin
export default {"wrapper":"MyRfq_wrapper__Omw5B","noRfq":"MyRfq_noRfq__Mtw3o","rfq":"MyRfq_rfq__X0xJN","sl":"MyRfq_sl__br2Bm","gridWrap":"MyRfq_gridWrap__TK6tr"};